import { ADD_USER_TO_GROUP_ACTIVITY, CLEAR_ACTIVITY_DETAILS, GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY, GET_ACTIVITY_DETAILS, GET_ACTIVITY_LIST_BY_DATE, GET_INTERESTED_USER_LIST, REMOVE_USER_FROM_GROUP_ACTIVITY } from '../../constants';

export function getActivityListByDate(data) {
    return {
        type: GET_ACTIVITY_LIST_BY_DATE,
        data
    };
}

export function getActivityDeatils(data) {
    return {
        type: GET_ACTIVITY_DETAILS,
        data
    };
}

export function clearActivityDeatils(data) {
    return {
        type: CLEAR_ACTIVITY_DETAILS,
        data
    };
}

export function getIntersestedUserList(data) {
    return {
        type: GET_INTERESTED_USER_LIST,
        data
    };
}

export function getActiveUsersListForGroupActivity(data) {
    return {
        type: GET_ACTIVE_USER_LIST_FOR_GROUP_ACTIVITY,
        data
    };
}

export function addActiveUsersListToGroupActivity(data) {
    return {
        type: ADD_USER_TO_GROUP_ACTIVITY,
        data
    };
}

export function removeUserFromGroupActivity(data) {
    return {
        type: REMOVE_USER_FROM_GROUP_ACTIVITY,
        data
    };
}